export default __webpack_public_path__ + "static/leaderboard-illus-75efc40c63efec819e1ff7f09d205461.png";